import { Component } from '@angular/core';
import { GlobalConstants } from 'src/app/common/global';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Services } from "src/app/services/api.service"
import { GetUserProfileService } from 'src/app/services/getUserProfile.service';
import { membershipTypes } from 'src/app/common/constants';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentInfoComponent } from 'src/app/components/payment-info/payment-info.component';
import { PaymentComponent } from 'src/app/components/payment/payment.component';

@Component({
  selector: 'app-membership-payment',
  templateUrl: './membership-payment.component.html',
  styleUrls: ['./membership-payment.component.sass'],
  standalone: true,
  imports: [CommonModule, TranslateModule, PaymentInfoComponent, PaymentComponent]
})
export class MembershipPaymentComponent {
  loader = document.getElementById("loader-container");
  orderId = document.location.pathname.split("/cart/")[1];
  page = document.location.pathname.split("/cart/")[0];
  cart: any;
  customerProfile: any;
  membershipTypes = membershipTypes;
  profileType: string = (this.route.snapshot.queryParams['type'] === "club-friend") ? membershipTypes.CLUB_FRIEND : membershipTypes.FULL_FLEDGED;

  constructor(
    private http: HttpClient, 
    public Services: Services,
    private userProfileService: GetUserProfileService,
    private route: ActivatedRoute,
  ) {
    this.getCart();
    this.getCustomerProfile();
  }

  getCart() {
    this.http.get(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/${this.orderId}`, GlobalConstants.headersCentral).subscribe({
      next: data => {
        let response:any = data;
        this.cart = response.data;
        this.loader!.style.display = "none";
      }, error: error => {
        if(error.status === 401) {
          //this.Services.logout();
        }
        this.loader!.style.display = "none";
      }
    })
  }

  getCustomerProfile() {
    this.userProfileService.getConnectionUserProfile().subscribe({
      next: (data: any) => {
        this.customerProfile = data.data;
      }
    });
  }

  cancelOrder() {
    localStorage.removeItem("orderInfo");
    sessionStorage.removeItem("removeData");

    let newUrl = {
      changeUrl: false,
      url: ""
    }

    this.Services.cancelOrder(this.orderId, false, newUrl);
  }
}
